export default "__VITE_ASSET__Dspjd3Tm__"